import { type BridgeInfo, parseBridgeInfo, ROUTES } from '@kinoq/camera-protocol';
import { bridgeUrl } from './desktopDiscovery';

export type BridgeProbe =
  | { kind: 'live'; info: BridgeInfo }
  | { kind: 'unknown' } // shell 404 + X-Rosa-Bridge: unknown
  | { kind: 'old' } // any other 404
  | { kind: 'unreachable'; message: string };

// Shorter than the 5 s poll, so a dead bridge's probes never pile up.
const PROBE_TIMEOUT_MS = 3000;

/** Asks a bridge `GET /bridge` through the shell. Never throws. */
export async function probeBridge(id: string, signal?: AbortSignal): Promise<BridgeProbe> {
  const timeout = AbortSignal.timeout(PROBE_TIMEOUT_MS);
  try {
    const response = await fetch(`${bridgeUrl(id)}${ROUTES.bridge}`, {
      signal: signal ? AbortSignal.any([signal, timeout]) : timeout,
    });
    if (response.status === 404) {
      return response.headers.get('X-Rosa-Bridge') === 'unknown'
        ? { kind: 'unknown' }
        : { kind: 'old' };
    }
    if (!response.ok) return { kind: 'unreachable', message: `bridge answered ${response.status}` };
    const info = parseBridgeInfo(await response.json());
    return info ? { kind: 'live', info } : { kind: 'unreachable', message: 'not a KinoQ bridge' };
  } catch (err) {
    return { kind: 'unreachable', message: err instanceof Error ? err.message : String(err) };
  }
}
